import { API, graphqlOperation } from 'aws-amplify';
import { updateMerchantAccount } from '../../graphql/mutations';
import { getMerchantAccount } from '../../graphql/queries';

const merchantAccount = {
  state: {
    merchantAccountDetails: null,
  },
  reducers: {
    SET_MERCHANT_ACCOUNT(state, payload) {
      return {
        ...state,
        merchantAccountDetails: payload,
      };
    },
  },
  effects: (dispatch) => ({
    setMerchantAccount(payload) {
      dispatch.merchantAccount.SET_MERCHANT_ACCOUNT(payload);
    },
    async updateMerchantAccount(payload, rootState) {
      const merchantAccountId = rootState?.auth?.user?.merchantAccount.id;
      payload.id = merchantAccountId;
      await API.graphql(
        graphqlOperation(updateMerchantAccount, {
          input: payload,
        }),
      );
      this.fetchAndSetMerchantAccount(merchantAccountId, rootState);
    },

    async fetchAndSetMerchantAccount(payload, rootState) {
      try {
        const merchantAccountId = rootState?.auth?.user?.merchantAccount.id;

        if (merchantAccountId) {
          const merchantAccountData = await API.graphql(
            graphqlOperation(getMerchantAccount, {
              id: merchantAccountId,
            }),
          );

          if (merchantAccountData) {
            dispatch.merchantAccount.SET_MERCHANT_ACCOUNT(
              merchantAccountData.data.getMerchantAccount,
            );
          }
        }
      } catch (error) {
        console.log(
          'error in [MerchantAccount]::fetchAndSetMerchantAccount::error',
          error,
        );
        throw error;
      }
    },
  }),
};

export default merchantAccount;
